(function () {
  if (window.DouxcouPages) return;
  window.DouxcouPages = true;

  const routes = window.routes || {};

  if (!customElements.get("product-card-add")) {
    customElements.define(
      "product-card-add",
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector("button");
          if (!this.button || this.bound) return;
          this.bound = true;
          this.button.addEventListener("click", () => this.add());
        }
        async add() {
          const id = Number(this.dataset.variantId);
          if (!id || this.button.disabled || !window.Douxcou) return;
          this.button.setAttribute("aria-busy", "true");
          this.button.disabled = true;
          try {
            await window.Douxcou.cart.add([{ id, quantity: 1 }]);
          } catch (err) {
            console.error(err);
            window.alert(err.message || "Impossible d'ajouter au panier.");
          } finally {
            this.button.disabled = false;
            this.button.removeAttribute("aria-busy");
          }
        }
      },
    );
  }

  document.addEventListener("click", (e) => {
    const reset = e.target.closest("[data-search-reset]");
    if (!reset) return;
    const input = reset.closest("form")?.querySelector("[data-search-input]");
    if (!input) return;
    input.value = "";
    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.focus();
  });

  if (!customElements.get("search-modal")) {
    customElements.define(
      "search-modal",
      class extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.dialog = this.querySelector("[data-search-dialog]");
          this.panel = this.querySelector("[data-search-panel]");
          this.overlay = this.querySelector("[data-search-overlay]");
          this.input = this.querySelector("[data-search-input]");
          this.results = this.querySelector("[data-predictive-results]");
          this.form = this.querySelector("form");
          this.url = this.dataset.predictiveUrl || routes.predictive_search_url || "/search/suggest";
          this.cache = new Map();

          this.onOpen = () => this.open();
          this.onClose = () => this.close();
          this.onKey = (e) => {
            if (e.key === "Escape" && this.isOpen) this.close();
          };
          this.onTrigger = (e) => {
            const trigger = e.target.closest("[data-search-open]");
            if (!trigger) return;
            e.preventDefault();
            this.open();
          };
          document.addEventListener("search:open", this.onOpen);
          document.addEventListener("search:close", this.onClose);
          document.addEventListener("keydown", this.onKey);
          document.addEventListener("click", this.onTrigger);

          this.overlay.addEventListener("click", () => this.close());
          this.querySelector("[data-search-close]").addEventListener("click", () => this.close());
          this.input.addEventListener("input", () => this.onInput());
          this.form.addEventListener("submit", (e) => {
            if (!this.input.value.trim()) e.preventDefault();
          });
        }

        disconnectedCallback() {
          document.removeEventListener("search:open", this.onOpen);
          document.removeEventListener("search:close", this.onClose);
          document.removeEventListener("keydown", this.onKey);
          document.removeEventListener("click", this.onTrigger);
          this.bound = false;
        }

        get isOpen() {
          return !this.dialog.hidden;
        }

        measure() {
          const header = document.querySelector(".cozy-header");
          let top = 50;
          let height = 208;
          if (header) {
            const r = header.getBoundingClientRect();
            top = Math.max(0, r.top);
            height = Math.max(128, r.height);
          }
          this.panel.style.top = `${top}px`;
          this.panel.style.height = `${height}px`;
          this.overlay.style.top = `${top + height}px`;
        }

        open() {
          if (this.isOpen) return;
          this.measure();
          this.dialog.hidden = false;
          this.input.value = "";
          this.render("");
          requestAnimationFrame(() => this.input.focus());
        }

        close() {
          if (!this.isOpen) return;
          this.dialog.hidden = true;
          this.abort?.abort();
          if (document.activeElement && this.contains(document.activeElement)) document.activeElement.blur();
          if (window.Douxcou?.search && !this.closing) {
            this.closing = true;
            document.dispatchEvent(new CustomEvent("search:close"));
            this.closing = false;
          }
        }

        onInput() {
          clearTimeout(this.timer);
          const term = this.input.value.trim();
          if (!term) return this.render("");
          this.timer = setTimeout(() => this.fetchResults(term), 250);
        }

        async fetchResults(term) {
          if (this.cache.has(term)) return this.render(this.cache.get(term));
          this.abort?.abort();
          this.abort = new AbortController();
          const params = new URLSearchParams({ q: term, section_id: "predictive-search" });
          params.set("resources[type]", "product,query");
          params.set("resources[limit]", "4");
          params.set("resources[options][unavailable_products]", "last");
          try {
            const res = await fetch(`${this.url}?${params}`, { signal: this.abort.signal });
            if (!res.ok) throw new Error(res.status);
            const text = await res.text();
            const doc = new DOMParser().parseFromString(text, "text/html");
            const dropdown = doc.querySelector("[data-predictive-dropdown]");
            const html = dropdown ? dropdown.outerHTML : "";
            this.cache.set(term, html);
            if (this.input.value.trim() === term) this.render(html);
          } catch (err) {
            if (err.name !== "AbortError") this.render("");
          }
        }

        render(html) {
          this.results.innerHTML = html;
          this.results.hidden = !html;
          this.input.setAttribute("aria-expanded", html ? "true" : "false");
        }
      },
    );
  }

  function listingFor(el) {
    return el.closest("[data-listing]");
  }

  function paramsFromForm(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (value !== "") params.append(key, value);
    });
    return params;
  }

  async function renderListing(listing, url, push = true) {
    const sectionId = listing.dataset.listing;
    const target = new URL(url, window.location.origin);
    const openIdx = [...listing.querySelectorAll("[data-facet-details]")]
      .map((d, i) => (d.open ? i : -1))
      .filter((i) => i >= 0);
    const mobileOpen = !listing.querySelector("[data-facet-mobile-panel]")?.hidden;
    const focusedName = document.activeElement?.name;

    listing.setAttribute("aria-busy", "true");
    listing.style.opacity = "0.6";
    try {
      const fetchUrl = new URL(target);
      fetchUrl.searchParams.set("section_id", sectionId);
      const html = await fetch(fetchUrl).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, "text/html");
      const fresh = doc.querySelector(`[data-listing="${sectionId}"]`);
      if (!fresh) throw new Error("section introuvable");
      listing.innerHTML = fresh.innerHTML;
      const details = listing.querySelectorAll("[data-facet-details]");
      openIdx.forEach((i) => details[i] && (details[i].open = true));
      if (mobileOpen) toggleMobile(listing, true);
      if (focusedName) listing.querySelector(`[name="${CSS.escape(focusedName)}"]`)?.focus({ preventScroll: true });
      if (push) history.pushState({ listing: sectionId }, "", target.pathname + target.search);
    } catch (err) {
      window.location.href = target.href;
    } finally {
      listing.removeAttribute("aria-busy");
      listing.style.opacity = "";
    }
  }

  function toggleMobile(listing, force) {
    const panel = listing.querySelector("[data-facet-mobile-panel]");
    const btn = listing.querySelector("[data-facet-mobile-toggle]");
    if (!panel || !btn) return;
    const open = force ?? panel.hidden;
    panel.hidden = !open;
    btn.setAttribute("aria-expanded", String(open));
  }

  function submitFacets(form) {
    const listing = listingFor(form);
    if (!listing) return form.submit();
    const url = `${window.location.pathname}?${paramsFromForm(form)}`;
    renderListing(listing, url);
  }

  let priceTimer;
  document.addEventListener("change", (e) => {
    const form = e.target.closest("[data-facet-form]");
    if (!form || e.target.type === "number") return;
    submitFacets(form);
  });
  document.addEventListener("input", (e) => {
    const form = e.target.closest("[data-facet-form]");
    if (!form || e.target.type !== "number") return;
    clearTimeout(priceTimer);
    priceTimer = setTimeout(() => submitFacets(form), 600);
  });
  document.addEventListener("submit", (e) => {
    const form = e.target.closest("[data-facet-form]");
    if (!form) return;
    e.preventDefault();
    submitFacets(form);
  });
  document.addEventListener("click", (e) => {
    const link = e.target.closest("[data-facet-link]");
    if (link) {
      const listing = listingFor(link);
      if (listing) {
        e.preventDefault();
        renderListing(listing, link.href);
      }
      return;
    }
    const toggle = e.target.closest("[data-facet-mobile-toggle]");
    if (toggle) {
      const listing = listingFor(toggle);
      if (listing) toggleMobile(listing);
      return;
    }
    document.querySelectorAll("[data-facet-details][open]").forEach((d) => {
      if (!d.contains(e.target)) d.open = false;
    });
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    document.querySelectorAll("[data-facet-details][open]").forEach((d) => {
      d.open = false;
      d.querySelector("summary")?.focus();
    });
  });
  window.addEventListener("popstate", () => {
    const listing = document.querySelector("[data-listing]");
    if (listing) renderListing(listing, window.location.href, false);
  });
})();
